{
  "header": {
    "brandName": "SmartASS Agents"
  },
  "hero": {
    "badge": "AI-Powered Workflow Automation",
    "titleLine1": "Automate Your Business",
    "titleLine2": "Without Writing Code",
    "description": "Build intelligent AI workflows visually. Connect your tools, automate repetitive tasks, and let smart AI agents handle customer conversations — all from one platform.",
    "ctaDashboard": "Go to Dashboard",
    "ctaStart": "Start Building Free",
    "benefit1": "Setup in 5 minutes",
    "benefit2": "Free to get started",
    "benefit3": "No setup fees",
    "scrollToExplore": "Scroll to explore"
  },
  "stats": {
    "fasterWorkflow": "Faster workflow creation",
    "hoursSaved": "Hours saved per month",
    "automated": "Automated availability",
    "uptime": "Uptime guarantee"
  },
  "features": {
    "tag": "Features",
    "title": "Everything You Need to Automate",
    "subtitle": "Powerful features designed for business users, not developers. Build, deploy, and scale with confidence.",
    "visualBuilder": "Visual Workflow Builder",
    "visualBuilderDesc": "Create powerful automations by simply dragging and dropping. No coding required — anyone can build sophisticated workflows in minutes.",
    "visualBuilderTag": "No-Code",
    "aiUnderstands": "AI That Understands",
    "aiUnderstandsDesc": "Our intelligent AI agents learn from context and remember conversations. Get smart responses that actually make sense for your business.",
    "aiUnderstandsTag": "AI-Powered",
    "integrations": "Seamless Integrations",
    "integrationsDesc": "Connect your favorite tools instantly. Email, calendars, CRMs, and more — all working together automatically.",
    "integrationsTag": "Connect Everything",
    "security": "Enterprise Security",
    "securityDesc": "Bank-level encryption and GDPR compliance built-in. Your data stays protected with multi-layered security architecture.",
    "securityTag": "Secure"
  },
  "howItWorks": {
    "tag": "How It Works",
    "title": "Up and Running in Minutes",
    "subtitle": "Three simple steps to transform how you work",
    "step": "STEP",
    "step1Title": "Connect Your Tools",
    "step1Desc": "Link your existing business tools in just a few clicks. We support all major platforms.",
    "step2Title": "Build Your Flow",
    "step2Desc": "Drag and drop to create your perfect workflow. No technical skills needed.",
    "step3Title": "Let AI Do the Work",
    "step3Desc": "Activate your flow and watch as AI handles tasks automatically, 24/7."
  },
  "useCases": {
    "tag": "Use Cases",
    "title": "Automate What Matters Most",
    "subtitle": "From customer support to sales — see how teams like yours are saving time every day",
    "support": "Customer Support",
    "supportDesc": "Automate responses, route inquiries intelligently, and resolve issues faster with AI-powered chat.",
    "supportBenefit1": "24/7 availability",
    "supportBenefit2": "Instant responses",
    "supportBenefit3": "Smart routing",
    "booking": "Appointment Booking",
    "bookingDesc": "Let customers book meetings automatically. No back-and-forth emails, just seamless scheduling.",
    "bookingBenefit1": "Calendar sync",
    "bookingBenefit2": "Auto reminders",
    "bookingBenefit3": "Multi-timezone",
    "email": "Email Automation",
    "emailDesc": "Send personalized emails at scale. From campaigns to transactional messages — all automated.",
    "emailBenefit1": "Templates",
    "emailBenefit2": "Personalization",
    "emailBenefit3": "Tracking",
    "leads": "Lead Qualification",
    "leadsDesc": "Automatically qualify and nurture leads. AI identifies hot prospects so your team can focus on closing.",
    "leadsBenefit1": "Smart scoring",
    "leadsBenefit2": "Auto follow-up",
    "leadsBenefit3": "CRM sync"
  },
  "testimonials": {
    "tag": "Testimonials",
    "title": "Loved by Teams Everywhere",
    "subtitle": "See what business leaders are saying about us",
    "quote1": "We reduced our response time from hours to seconds. Our customers are thrilled!",
    "quote2": "The visual workflow builder is a game-changer. I built our entire lead process in one afternoon.",
    "quote3": "Finally, AI automation that actually understands context. It feels like having a smart assistant."
  },
  "enterprise": {
    "tag": "Enterprise Ready",
    "title": "Built for Scale & Security",
    "description": "Enterprise-grade infrastructure that grows with your business. Multi-tenant architecture, GDPR compliance, and 99.9% uptime guaranteed.",
    "feature1": "Multi-tenant data isolation",
    "feature2": "Role-based access control",
    "feature3": "SOC 2 Type II compliant",
    "feature4": "End-to-end encryption",
    "feature5": "Dedicated support",
    "microservices": "14 Microservices",
    "workingTogether": "Working Together"
  },
  "cta": {
    "title": "Ready to Transform Your Workflow?",
    "subtitle": "Join thousands of businesses automating their operations with SmartAss AI. Start free and scale as you grow.",
    "ctaDashboard": "Access Dashboard",
    "ctaStart": "Get Started Free",
    "contactSales": "Contact Sales"
  },
  "footer": {
    "copyright": "© {{year}} All rights reserved.",
    "tagline": "Enterprise-grade AI workflow automation"
  }
}
